import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../../contexts/UserContext";
import "./Navbar.css";

const NavBar = () => {
  const { user, logout } = useContext(UserContext);
  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const dropdownRef = useRef(null);
  const navbarRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/login-admin");
    setExpanded(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        navbarRef.current &&
        !navbarRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Navbar expand="lg" variant="dark" sticky="top" className="navbaaar" expanded={expanded} ref={navbarRef}>
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          <img src="/img/marca/faviConBlanco.png" alt="WhiskyAndCo" height="50" />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={() => setExpanded(!expanded)}
        />

        <Navbar.Collapse id="navbar-nav">
          <Nav className={user?.rol === "Admin" ? "navLinksAdmin" : "navLinksPublic"} onClick={() => setExpanded(false)}>
            <Nav.Link className="linkHover" as={Link} to="/">Inicio</Nav.Link>
            <Nav.Link className="linkHover" as={Link} to="/productos">Productos</Nav.Link>
            <Nav.Link className="linkHover" as={Link} to="/contacto">Contacto</Nav.Link>
            <Nav.Link className="linkHover" as={Link} to="/nosotros">Nosotros</Nav.Link>
          </Nav>

          {user?.rol === "Admin" && (
            <Nav ref={dropdownRef}>
              <NavDropdown
                title={
                  <>
                    <FontAwesomeIcon icon={faUserShield} />
                    {` ${user.username}`}
                  </>
                }
                id="nav-dropdown"
                align="end"
                show={showDropdown}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <NavDropdown.Item
                  className="dropDownNavbar"
                  as={Link}
                  to="/admin"
                  onClick={() => {
                    setShowDropdown(false);
                    setExpanded(false);
                  }}
                >
                  Panel de Admin
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout} className="dropDownNavbar">
                  <FontAwesomeIcon icon={faRightFromBracket} /> Cerrar sesion
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
